import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type {
  IExportDataTypesResponse,
} from '../types';
import {
  EXPORT_DATA_PERMISSIONS,
  EXPORT_DATA_TYPES_QUERY_KEY,
  EXPORT_DATA_TYPES_URL,
} from '../constants';

export default function useExportDataTypesQuery(): IContextQueryResult<
  IExportDataTypesResponse
> {
  const { fetchGet } = useRestClient();

  return useContextQuery<
    IExportDataTypesResponse
  >({
    queryKey: [EXPORT_DATA_TYPES_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet<IExportDataTypesResponse>(
      EXPORT_DATA_TYPES_URL,
      {
        signal,
        permission: EXPORT_DATA_PERMISSIONS.CREATE,
      },
    ),
  });
}
